import React from "react";

import { SubHeader, Typography, Button } from "clearsense-ui/components";

import { FHIR_RESOURCE_TYPES } from "./constants";
import { convertToProperCase } from "./utils";

const InformationGuideHome = () => (
  <div className="cs-ui-container cs-ui-container__table">
    <SubHeader
      className="mt-8 mb-2"
      breadcrumbs={[
        { label: "Reference Data", link: "#" },
        { label: "FHIR Information Guide", link: "#" },
        { label: "Overview", link: "#" },
      ]}
    />
    <Typography style="h3" type="semibold" className="cursor-pointer mb-3">
      US Core Implementation Guides : Profiles
    </Typography>
    <div className="flex flex-col p-3 h-screen overflow-y-auto overflow-x-hidden cs-ui-scrollbar">
      {FHIR_RESOURCE_TYPES.map((resourceType, index) => (
        <div key={index} className="flex flex-col">
          <Typography style="h4" type="semibold">
            {resourceType.title}
          </Typography>
          {resourceType.resources.map((resource, index) => (
            <Button
              key={index}
              className="text-primary-shade cursor-pointer w-max font-normal"
              to={`${resource.value}`}
              style="link"
              label={`US Core ${convertToProperCase(resource.label)} Profile`}
            />
          ))}
        </div>
      ))}
    </div>
  </div>
);
export default InformationGuideHome;
